import React from 'react';
import { NavLink } from 'react-router-dom';

function NavLinks({ onClick }) {
  const navClass = ({ isActive }) => (isActive ? 'active' : '');

  return (
    <>
      <NavLink to="/" end className={navClass} onClick={onClick}>HOME</NavLink>
      <NavLink to="/about" className={navClass} onClick={onClick}>ABOUT</NavLink>
      <NavLink to="/mission" className={navClass} onClick={onClick}>MISSION</NavLink>
      <NavLink to="/vision" className={navClass} onClick={onClick}>VISION</NavLink>
      <NavLink to="/services" className={navClass} onClick={onClick}>SERVICES</NavLink>
      <NavLink to="/contact" className={navClass} onClick={onClick}>CONTACT</NavLink>
    </>
  );
}

export default NavLinks;
